import { Injectable } from '@angular/core';
import { API } from './api.service';
import * as _ from 'lodash';
@Injectable()
export class TooltipService {
  public tooltips = [];
  constructor(private api: API) {
    this.loadTooltips();
  }

  loadTooltips() {
    this.api.get('api/tooltips').subscribe((data) => {
      _.each(data, (value, key) => {
        this.tooltips[key] = value.label;
      });
    });
  }

  get(key: string) {
    let tooltip = typeof this.tooltips[key] === 'undefined' ? key.replace(new RegExp('_', 'g'), ' ') :
      this.tooltips[key]; //REG EXP for replacing all
    return tooltip;
  }

}



// WEBPACK FOOTER //
// ./src/app/api/services/tooltip.service.ts